import axios from 'axios';
import { ICatFilters } from '../../redux/state/catalogueState';
import { catalogueFields } from '../../util/catalogue/catalogueFields';

export const fetchCatalogues = (limit: number = 50, offset: number = 0, order: string, orient: string = "asc", filters: ICatFilters, isQuoteCatalogue = false) => {
    let url = `/api/v1/products?term[productType]=1,2&&source=cp&isDeleted=0&limit=${limit}&offset=${offset}&order=${order}&orient=${orient}`;
    if(isQuoteCatalogue){
        url += '&isQuoteCatalogue=true'
    }

    for (let key in filters) {
        if (key == "mainSearch" || key == "source") {
            continue;
        }
        if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'inhouseId')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'categoryName')) {
            url += `&term[categoryName]=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'productName')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters["mainSearch"] == "" && filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'productId')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && filters[key] && !Array.isArray(filters[key]) && (['inhouseId', "productName", "productId"].indexOf(key) === -1)) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && Array.isArray(filters[key]) && filters[key].filter(f => f !== '').length > 0) {
            url += `&${key}=[${filters[key]}]`
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        }
    }
    if (filters["mainSearch"] != "") {
        url += `&search=${filters["mainSearch"]}`;
    }
    return axios.get(url);
};
// A quote id always requests quote-specific rows and prices, regardless of
// which quote detail route initiated the request.
export const fetchCatalogue = (id, account_id, qid = null) => {
    if (account_id) {
        let url = `/api/v1/products/` + id + `?source=cp&account_id=` + account_id;
        if (qid) url += `&order_id=${qid}`;
        return axios.get(url);
    } else {
        let url = `/api/v1/products/` + id + `?source=cp`;
        if (qid) url += `&order_id=${qid}`;
        return axios.get(url);
    }
};
export const fetchCatalogueCategories = (session = null) => {
    let url = `/api/v1/products/categories?source=cp`;
    if (session) {
        if (session.user.accountId) {
            url += `&account_id=${session.user.accountId}`;
        }
        if (session.user.accountId) {
            url += `&contact_id=${session.user.contactId}`;
            url += `&cp_user_id=${session.user.contactId}`;
        }
    }
    url += `&limit_catalog_to_products_connected=true`;
    return axios.get(url);
};
export const createOrder = (data) => {
    let url = `/api/v1/orders`;

    return axios.post(url, data);
};
export const createOrderItem = (data, id) => {
    let url = `/api/v1/orders/` + id + `/items`;

    return axios.post(url, data);
};
export const createOrderItemRow = (data, id, itemid) => {
    let url = `/api/v1/orders/` + id + `/items/` + itemid + `/rows`;

    return axios.post(url, data);
};
export const createOrderItemRowDecoration = (data, id, itemid, rowid) => {
    let url = `/api/v1/orders/` + id + `/items/` + itemid + `/rows/` + rowid + `/decorations`;

    return axios.post(url, data);
};
export const updateOrderItemRowDecoration = (data, id, itemid, rowid) => {
    let url = `/api/v1/orders/` + id + `/items/` + itemid + `/rows/` + rowid + `/decorations/` + data.id;

    return axios.put(url, data);
};
export const updateRowItem = (qid, id, data) => {
    let url = `/api/v1/orders/` + qid + `/items/` + id + `/rows/` + data.id;
    return axios.put(url, data);
};
export const uploadArtwork = (data) => {
    let url = `/content/file-upload`;
    const formData = new FormData()
    formData.append('File', data.File, data.File.name)
    return axios.post(url, formData);
};
export const fetchDecorationLocations = () => {
    let url = `/api/v1/decorations/locations`;
    return axios.get(url);
};
export const fetchArtworkdetail = (id) => {
    let url = `/api/v1/artwork/` + id;

    return axios.get(url);
};
export const fetchDecorationTypes = () => {
    let url = `/api/v1/decorations/types?limit=100`;

    return axios.get(url);
};
export const fetchArtworks = (filterData) => {
    let url = `/api/v1/artwork?source=cp&termIn[statusName][]=Done&term[isInactive]=0`;
    if (filterData.accountId) {
        url += `&account_id=${filterData.accountId}`;
    }
    if (filterData.contactId) {
        url += `&term[contact_id]=${filterData.contactId}`;
    }
    return axios.get(url);
};
export const fetchArtworksById = (filterData) => {
  let url = `/api/v1/artwork?source=cp&termIn[statusName][]=Done&term[isInactive]=0`

  for (let key in filterData) {
    if (key === 'account_id') {
      url += `&${key}=${filterData[key]}`
    } else if (key === 'product_id') {
      url += `&${key}=${filterData[key]}`
    }
  }
  //axios.defaults.headers.common['Authorization'] =
  //  `Basic ` + Buffer.from(window.apiToken + ':').toString('base64')
  //axios.defaults.headers.common['Access-Control-Allow-Origin'] = `* `

  return axios.get(url)
}
export const getDecoratorTypes = () => {
    let url = `/content/get-decorator-types-all/`;

    return axios.get(url);
};
export const getDecoratorVendors = () => {
    let url = `/content/get-decorator-vendors`;

    return axios.get(url);
};
export const createArtwork = (data) => {
    let url = `/api/v1/artwork`;

    return axios.post(url, data);
};


export const fetchShippingLocations = (accountId) => {
    let url = `/api/v1/locations?term[accountId]=${accountId}`;
    return axios.get(url);
};

export const getContactInfo = (contactId) => {
    let url = `/api/v1/contacts/` + contactId;
    return axios.get(url);
};
